"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.min = exports.max = exports.distinctItem = exports.distinct = exports.avg = exports.sum = void 0;
/**
 * sumuje wartości w tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function sum(array, prop) {
    var $result = 0;
    if (prop) {
        return array.reduce(function (a, b) { return a[prop] + b[prop]; }, 0);
    }
    else {
        return array.reduce(function (a, b) { return a + b; }, 0);
    }
}
exports.sum = sum;
/**
 * średnia wartośc z tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function avg(array, prop) {
    var $result = 0;
    if (prop) {
        return array.reduce(function (a, b) { return a[prop] + b[prop]; }, 0) / array.length;
    }
    else {
        return array.reduce(function (a, b) { return a + b; }, 0) / array.length;
    }
}
exports.avg = avg;
/**
 * unikalne wartości z tablicy
 * @param array tablica do sumowania
 * @param prop zwracane pole z wiersza tablicy
 */
function distinct(array, prop) {
    var $result = [];
    var $distinct = {};
    if (prop) {
        for (var i = 0; i < array.length; i++) {
            var $v = array[i][prop];
            if ($distinct[$v] === undefined) {
                $result.push($v);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (var i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.distinct = distinct;
/**
 * unikalne wiersze z tablicy
 * @param array tablica do sumowania
 * @param prop pole do określenia unikalności wiersza
 */
function distinctItem(array, prop) {
    var $result = [];
    var $distinct = {};
    if (prop) {
        for (var i = 0; i < array.length; i++) {
            var $v = array[i][prop];
            if ($distinct[$v] === undefined) {
                $result.push(array[i]);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (var i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.distinctItem = distinctItem;
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function max(values, prop) {
    var result = values[0];
    var i = values.length;
    if (prop) {
        while (--i > 0) {
            var $v = values[i][prop];
            if ($v > result) {
                result = $v;
            }
        }
    }
    else {
        while (--i > 0) {
            if (values[i] > result) {
                result = values[i];
            }
        }
    }
    return result;
}
exports.max = max;
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function min(values, prop) {
    var result = values[0];
    var i = values.length;
    if (prop) {
        while (--i > 0) {
            var $v = values[i][prop];
            if ($v < result) {
                result = $v;
            }
        }
    }
    else {
        while (--i > 0) {
            if (values[i] < result) {
                result = values[i];
            }
        }
    }
    return result;
}
exports.min = min;
//# sourceMappingURL=aggreagate.js.map